import ErrorRobot from '@anm/components/errors/ErrorRobot';
import errors, { StatusCode } from '@anm/data/errors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { pricingSelectors } from '../../../../store/modules/pricing';

const usePricingError = () => {
  const plansError = useSelector(
    pricingSelectors.selectPricingSubscriptionPlansError
  );

  const contentError = useSelector(pricingSelectors.selectPricingContentError);
  const errorCode = plansError?.code || contentError?.code;
  const isError = !!errorCode;

  const errorBlock = useMemo(
    () =>
      isError ? (
        <ErrorRobot
          {...errors(errorCode as StatusCode)}
          backgroundVariant="white-to-light-blue"
        />
      ) : null,
    [isError, errorCode]
  );

  return [isError, errorBlock] as const;
};

export default usePricingError;
